import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { C, T } from 'shared/helpers';

import Styles from './Radio.module.scss';

export default function Radio({
  state,
  setter,
  onChoice,
  onOff,
  choiceId,
  label,
  textOnRight,
  initialValue,
  style,
  outerCircleStyle,
  innerCircleStyle,
  labelStyle,
}) {
  const { Radio, Flex } = Styles;
  const [selected, setSelected] = useState(initialValue);

  useEffect(() => {
    if (state instanceof Object) {
      setSelected(state[choiceId]);
    }
  }, [state, choiceId]);

  useEffect(() => {
    onOff(choiceId);
  }, [onOff, choiceId, selected]);

  return (
    <div
      style={{ ...style }}
      onClick={() => {
        if (state instanceof Object) {
          const S = {};
          Object.keys(state).map(x => (S[x] = x === choiceId));
          setter(S);
          onChoice(choiceId);
        }
      }}
      className={C(Radio, [textOnRight, Flex])}
    >
      <div style={{ ...outerCircleStyle }}>
        {T(state, {})[choiceId] && <div style={{ ...innerCircleStyle }} />}
      </div>
      <p style={{ ...labelStyle }}>{label || choiceId}</p>
    </div>
  );
}

Radio.defaultProps = {
  onChoice: () => {},
  onOff: () => {},
  style: {},
  outerCircleStyle: {},
  innerCircleStyle: {},
  labelStyle: {},
  initialValue: false,
  textOnRight: false,
  label: '',
};

Radio.propTypes = {
  state: PropTypes.object.isRequired,
  setter: PropTypes.func.isRequired,
  onChoice: PropTypes.func,
  onOff: PropTypes.func,
  choiceId: PropTypes.string.isRequired,
  label: PropTypes.string,
  style: PropTypes.object,
  outerCircleStyle: PropTypes.object,
  innerCircleStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  initialValue: PropTypes.bool,
  textOnRight: PropTypes.bool,
};
